module.exports = __webpack_public_path__ + "static/coldstorage-bef07d8b38ed58f2f028d967f237219e.png";